import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const CALLSCRIPTS_API_URL = "dialer/call-scripts/";

export const fetchCallScripts = createAsyncThunk("callscripts/fetchCallScripts", async (params, thunkAPI) => {
    try {
        const state = thunkAPI.getState();
        const token = state.auth.token;
        if (!token) return;

        const response = await axios.get(CALLSCRIPTS_API_URL, {
            params: params,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response?.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(
            error.response?.data?.message ||
            error.message ||
            "Failed to fetch call scripts list"
        );
    }
});

const callScriptsSlice = createSlice({
    name: "callscripts",
    initialState: {
        callscripts_list: [],
        callscripts_list_loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchCallScripts.pending, (state) => {
            state.callscripts_list_loading = true;
            state.error = null;
        })
        .addCase(fetchCallScripts.fulfilled, (state, action) => {
            state.callscripts_list_loading = false;
            state.callscripts_list = action.payload;
        })
        .addCase(fetchCallScripts.rejected, (state, action) => {
            state.callscripts_list_loading = false;
            state.error = action.payload || "Something went wrong";
            state.callscripts_list = [];
        });
    },
});


export default callScriptsSlice.reducer;